export const IS_ALLOWED_ENVIRONMENT =
  process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_CYPRESS !== 'true'

export const IS_SILENCED = process.env.NEXT_PUBLIC_SILENCE_APP_ROOT_PROVIDER === 'true'

export const IS_DEV_ENVIRONMENT = process.env.NODE_ENV === 'development'
